<template>
  <div id="price-range">

    <h2 class="price-range__title">
      Ihre Fahrzeugbewertung
    </h2>


    <p class="price-range__description">
      Angebotspreis {{name}}
    </p>

    <p v-if="!medianPrice" class="price-range__description gray">
      Leider konnten wir keinen Ankaufpreis für deinen
      <br>
      {{name}} ermitteln
    </p>

    <div v-if="medianPrice" class="price-range__wrapper">
      <div class="price-range__block--price">
        <div class="price-range__block--price-item">{{ formatPrice(lead.valuated_price_low) }}</div>
        <div class="price-range__block--price-item">{{ formatPrice(medianPrice) }}</div>
        <div class="price-range__block--price-item">{{ formatPrice(lead.valuated_price_high) }}</div>
      </div>
      <div class="price-range__block--text">
        <div class="price-range__block--text-item">Min.</div>
        <div class="price-range__block--text-item">Durchschnittlicher Angebotspreis</div>
        <div class="price-range__block--text-item">Max.</div>
      </div>
      <div class="price-range__block">
        <div class="price-range__block-item"/>
        <div class="price-range__block-item"/>
        <div class="price-range__block-item"/>
      </div>

      <div class="price-range__block-text">
        Alle Angaben ohne Gewähr.
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['name', 'lead'],
    computed: {
      medianPrice: function () {
        const priceLow = this.lead.valuated_price_low;
        const priceHigh = this.lead.valuated_price_high;

        if (!priceLow || !priceHigh) {
          return null;
        }

        const result = (priceLow + priceHigh) / 2;
        return result.toFixed(0);
      }
    },
    methods: {
      formatPrice: function (price) {
        const formattedValue = Number(price).toLocaleString("de-DE");

        return `${formattedValue} €`;
      }
    }
  }
</script>

<style lang="scss">
  $green-border-color: rgb(91, 144, 105);
  #price-range {
    padding: 0 18px 55px;
  }

  .price-range__title {
    color: #010101;
    font-family: "Asap", sans-serif;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 25px;
  }

  .price-range__description {
    font-size: 18px;
    margin-bottom: 40px;

    &.gray {
      color: #737373;
      line-height: 1.6;
    }
  }

  .price-range__block {
    background: rgb(216, 231, 221);
    height: 65px;
    width: 100%;
    display: flex;

    &-text {
      text-align: left;
      margin-top: 5px;
      font-size: 12px;
      color: #010101;
    }
    &-item {
      flex: 1;

      &:nth-child(1),
      &:nth-child(3) {
        position: relative;

        &:before {
          position: absolute;
          content: '';
          bottom: 0;
          left: 0;
          width: 2px;
          height: 140%;
          background: $green-border-color;
        }
      }

      &:nth-child(3) {
        &:before {
          left: initial;
          right: 0;
        }
      }

      &:nth-child(2) {
        border-left: 2px solid $green-border-color;
        border-right: 2px solid $green-border-color;
      }
    }


    &--price,
    &--text {
      display: flex;
      justify-content: space-between;
    }

    &--text {
      margin-bottom: 35px;

      @media (max-width: 425px) {
        margin-bottom: 15px;
      }

      &-item {
        font-size: 15px;

        @media (max-width: 425px) {
          font-size: 14px;
          max-width: 100px;
        }
      }
    }

    &--price {
      margin-bottom: 15px;
      &-item {
        font-size: 28px;
        font-weight: 500;
        font-family: "Asap", sans-serif;

        @media (max-width: 425px) {
          font-size: 14px;
        }

        &:nth-child(2) {
          font-weight: 700;
          color: rgb(73, 132, 89);
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/summary/SummaryPriceRange.vue